import { lazy } from "react";
import { Navigate } from "react-router-dom";

const AccountDetailsComponent = lazy(
  () => import("pages/AdminConsole/Account/AccountDetailsComponent")
);

const AccountSubscription = lazy(
  () => import("pages/AdminConsole/Subscription/AccountSubscription")
);

const Team = lazy(() => import("pages/AdminConsole/Team/Team"));

const DataCollectors = lazy(
  () => import("pages/AdminConsole/Collections/DataCollectors/DataCollectors")
);

const CollectorCredentials = lazy(
  () => import("pages/AdminConsole/Collections/Credentials/CollectorCredentials")
);

const Resources = lazy(() => import("pages/AdminConsole/Collections/Resources/Resources"));

const Tags = lazy(() => import("pages/AdminConsole/Tags/Tags"));
const CostManagement = lazy(() => import("pages/AdminConsole/CostManagement/CostManagement"));
const Integrations = lazy(() => import("pages/AdminConsole/Integrations/Integrations"));

const NotificationChannels = lazy(
  () => import("pages/AdminConsole/Monitoring/NotificationChannels/NotificationChannels")
);
const AlertTypes = lazy(() => import("pages/AdminConsole/Monitoring/AlertTypes/AlertTypes"));
const CustomQueries = lazy(
  () => import("pages/AdminConsole/Monitoring/CustomMonitoringQueries/CustomQueries")
);
const AlertRules = lazy(() => import("pages/AdminConsole/Monitoring/AlertRules/AlertRules"));
import MonitoringProfiles from "pages/AdminConsole/Monitoring/Profiles/MonitoringProfiles";

const SilencingWindows = lazy(
  () => import("pages/AdminConsole/Monitoring/SilencingWindows/SilencingWindows")
);

const ReportTemplate = lazy(
  () => import("pages/AdminConsole/Reporting/ReportTemplate/ReportTemplate")
);

const ReportSubscriptions = lazy(
  () => import("pages/AdminConsole/Reporting/ReportSubscriptions/ReportSubscriptions")
);

const ReportHistory = lazy(
  () => import("pages/AdminConsole/Reporting/ReportHistory/ReportsHistory")
);

const OpportunityTypes = lazy(
  () => import("pages/AdminConsole/Opportunities/Types/OpportunityTypes")
);

const OpportunityPolicies = lazy(
  () => import("pages/AdminConsole/Opportunities/Policies/OpportunityPolicies")
);

export const adminConsole = [
  {
    path: "admin_console",
    element: <Navigate to="account" replace />,
  },
  {
    path: "admin_console",
    children: [
      {
        path: "account",
        element: <AccountDetailsComponent />,
      },
      {
        path: "subscriptions",
        element: <AccountSubscription />,
      },
      {
        path: "team",
        element: <Team />,
      },
      {
        path: "collections",
        element: <Navigate to="data_collectors" replace />,
      },
      {
        path: "collections",
        children: [
          {
            path: "data_collectors",
            element: <DataCollectors />,
          },
          {
            path: "collector_credentials",
            element: <CollectorCredentials />,
          },
          {
            path: "resources",
            element: <Resources />,
          },
        ],
      },
      {
        path: "monitoring",
        element: <Navigate to="notification_channels" replace />,
      },
      {
        path: "monitoring",
        children: [
          {
            path: "notification_channels",
            element: <NotificationChannels />,
          },
          {
            path: "profiles",
            element: <MonitoringProfiles />,
          },
          { path: "alert_types", element: <AlertTypes /> },
          { path: "custom_monitoring_queries", element: <CustomQueries /> },
          { path: "alert_rules", element: <AlertRules /> },
          {
            path: "silencing_windows",
            element: <SilencingWindows />,
          },
        ],
      },
      {
        path: "tags",
        element: <Tags />,
      },
      { path: "integrations", element: <Integrations /> },
      { path: "cost_management", element: <CostManagement /> },

      {
        path: "reporting",
        element: <Navigate to="templates" replace />,
      },
      {
        path: "reporting",
        children: [
          {
            path: "templates",
            element: <ReportTemplate />,
          },
          {
            path: "subscriptions",
            element: <ReportSubscriptions />,
          },
          { path: "history", element: <ReportHistory /> },
        ],
      },
      {
        path: "opportunity",
        element: <Navigate to="opportunity_types" replace />,
      },
      {
        path: "opportunity",
        children: [
          {
            path: "opportunity_types",
            element: <OpportunityTypes />,
          },
          {
            path: "opportunity_policies",
            element: <OpportunityPolicies />,
          },
        ],
      },
    ],
  },
];
